import { FeatureName } from "@faire/web-api--source/indigofair/data/FeatureName";
import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";

import { ModalTypeOrFeature } from "./type";

export const featureToPromoModalType = (
  modalTypeOrFeature: ModalTypeOrFeature | undefined
): PromoModalType | undefined => {
  if (!modalTypeOrFeature) {
    return undefined;
  }

  if (isFromConductor(modalTypeOrFeature)) {
    return PromoModalType.CONDUCTOR_MODAL;
  }

  return modalTypeOrFeature as PromoModalType;
};

const isFromConductor = (
  modalTypeOrFeature: ModalTypeOrFeature | undefined
): boolean => {
  return Object.values(FeatureName).includes(modalTypeOrFeature as FeatureName);
};
